export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-file-shield-2-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or store your online activity. Your privacy is our top priority with our strict no-logs policy.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Anonymous Browsing',
      description: 'Browse the internet completely anonymously. Hide your IP address and location from websites, advertisers, and trackers.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously. Use CAISA VPN on your computer, smartphone, tablet, and more with a single account.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Kill Switch Protection',
      description: 'Automatic kill switch instantly disconnects your internet if VPN connection drops, ensuring your data never leaks accidentally.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-br from-gray-900 via-teal-900 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-teal-400 text-sm font-semibold mb-4">Why Choose CAISA</p>
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            Advanced Features<br />
            Built for Security
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:border-teal-400 hover:bg-white/15 transition-all duration-300 group"
            >
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-500/20 rounded-xl group-hover:bg-teal-500 transition-colors flex-shrink-0">
                  <i className={`${feature.icon} text-2xl text-teal-400 group-hover:text-white transition-colors`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">{feature.title}</h3>
                  <p className="text-gray-300 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}